import React, {Component} from 'react'

import Item from '../../components/Item'
import Media from '../../components/Media'
import Asset from '../../models/Asset'
import Entry from '../../models/Entry'
import Each from '../../utils/Each'

class Sponsors extends Component {

  render () {
  	
  	const {item} = this.props;

    return (<div className={this.props.className}><Entry id={item.sponsors} results={

				(items) => (

						<Each items={items} render={ (item) => (
								<div className={this.props.itemClass}>

									<Item modifiers={['logo']}>
										<a href={item.externalUrl} target="_blank">
											<div className="Item-media">
												<Media id={item.image[0]} original={true} fluid={true} />
											</div>
										</a>
									</Item>


								</div>
						)}/>
				)
		}/></div>)
  }
}

export default Sponsors



// WEBPACK FOOTER //
// ./src/js/components/Sponsors/Sponsors.jsx